import { ButtonGroup } from 'ui/components/ButtonGroup'
import { Button } from 'ui/components/Buttons'

import { ActionsProps } from './interface'

import { Wrapper } from './styles'

export const Actions = ({ showNewButton, onOpenCreateModal }: ActionsProps) => (
  <Wrapper>
    <ButtonGroup margin="small">
      {showNewButton && (
        <Button face="tertiary" onClick={onOpenCreateModal}>
          Create New
        </Button>
      )}
    </ButtonGroup>
  </Wrapper>
)
